import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { VisuallyHidden } from '@change-corgi/design-system-legacy/a11y';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { ShareContainer } from '../share';
import { SignatureStatsActiveContainer } from '../stats/signatureStats';

export const SideSignedNonPromotableContainer: React.FC = () => {
	return (
		<>
			<Box mb={8}>
				<SignatureStatsActiveContainer />
			</Box>
			<VisuallyHidden as="h2">
				<Translate value="fe.components.petition_share.action" />
			</VisuallyHidden>
			<ShareContainer forMobileView={false} />
		</>
	);
};
